module.exports = __webpack_public_path__ + "public/images/curated-what-is-outschool-frame-mobile.34949ee250189ff4d3854fe2fec1d1f4.svg";